import { Theme } from '@mui/system';

type Asset = () => string;

export enum ThemeMode {
	'light' = 'light',
	'dark' = 'dark'
}

export interface IThemeProps {
	isDarkTheme: boolean;
}

export interface IThemeChangeProps extends IThemeProps {
	onThemeChange: (isDarkTheme: boolean) => void;
}

export interface ITheme extends Theme {
	assets: {
		socials: {
			Apple: Asset;
			Google: Asset;
			Github: Asset;
			Facebook: Asset;
			Microsoft: Asset;
			Gitlab: Asset;
			Discord: Asset;
			Linkedin: Asset;
			icons: {
				AppleIcon: Asset;
				GithubIcon: Asset;
				FacebookIcon: Asset;
				FingerprintIcon: Asset;
				PasskeyIcon: Asset;
				GoogleIcon: Asset;
				SSOIcon: Asset;
				MicrosoftIcon: Asset;
				LinkedinIcon: Asset;
				GitlabIcon: Asset;
				DiscordIcon: Asset;
			};
		};
		connectors: {
			SmtpIcon: Asset;
			SendGridIcon: Asset;
			TwilioIcon: Asset;
		};
		descope: {
			DescopeLogo: Asset;
			DescopeLogoSymbol: Asset;
		};
		general: {
			Cat: Asset;
			DevRevBubble: Asset;
		};
	};
}
